<ndt-add-account-extension-view
   [callState]="callState$ | async"
   [form]="form"
   [minTimeoutValue]="minTimeoutValue"
   [maxTimeoutValue]="maxTimeoutValue"
   [existingExtensions]="existingExtensions"
   [isEdit]="isEdit"
   (formCanceled)="onCancel()"
   (formSubmitted)="onSubmit($event)"
   (setupKeysClicked)="onSetupKeys()"
>
</ndt-add-account-extension-view>
